import type { one_to_one } from '@fireworkhq/proto-contract'
import { actionsSelector, type useStoreApi } from '@liveHelper/models/store'
import type { ClientRole } from 'agora-rtc-sdk-ng'

import { logError } from '@core/logging'

function validateVideoCallData(
  videoCall: one_to_one.shared.VideoCall = {},
): videoCall is one_to_one.shared.VideoCall {
  const { agent_id, credential, id } = videoCall
  const agoraCredential = credential?.agora

  if (
    !agoraCredential?.channel ||
    !agoraCredential?.uid ||
    !agoraCredential?.token ||
    !agent_id ||
    !id
  ) {
    logError(new Error('Missing id, channel, uid, agent_id, or token'), {
      captureContext: {
        extra: {
          channel: agoraCredential?.channel,
          token: agoraCredential?.token,
          uid: agoraCredential?.uid,
          agent_id,
          id,
        },
      },
    })
    return false
  }
  return true
}

/** @returns Whether the call successfully started. */
export function startCall(
  callData: one_to_one.shared.VideoCall | undefined,
  clientRole: ClientRole,
  storeApi: ReturnType<typeof useStoreApi>,
): boolean {
  if (!validateVideoCallData(callData)) {
    return false
  }

  const actions = actionsSelector(storeApi.getState())
  const { credential, agent_id, id } = callData
  const agoraCredential = credential?.agora

  actions.establishCall(
    {
      id: id ?? '',
      agentId: agent_id ?? '',
      channel: agoraCredential?.channel ?? '',
      uid: agoraCredential?.uid ?? '',
      token: agoraCredential?.token ?? '',
    },
    clientRole,
  )

  return true
}
